export const business = {
    name: "Bachmann",
    legalName: "Bachmann Events & More",
    contact: {
        email: "info@bachmann-catering.com",
        phone: "Tel.: 09133 – 76 979 56",
        address: {
            street: "Erlanger Str. 17",
            zip: "91083",
            city: "Baiersdorf",
            state: "Bayern",
            country: "Deutschland"
        }
    },
    legal: {
        vatId: "DE 312 312 312"
    },
    social: {
        instagram: "https://instagram.com/bachmann_catering",
        facebook: "https://facebook.com/bachmann.catering",
    },
    seo: {
        title: "Bachmann Events & More - Bio-Catering in Nürnberg, Fürth & Erlangen",
        description: "Ihr Experte für hochwertiges Bio-Catering in der Metropolregion. Seit 30 Jahren verwöhnen wir Sie mit nachhaltigem Eventcatering, Gourmet Catering und regionalen Spezialitäten für jeden Anlass.",
        keywords: [
            "Catering Erlangen",
            "Hochzeitscatering Erlangen",
            "Firmencatering",
            "Partyservice Erlangen",
            "Buffet",
            "Fingerfood",
            "Event Catering",
            "Bachmann"
        ]
    },
    navigation: {
        main: [
            { name: "Leistungen", href: "/#services" },
            { name: "Über uns", href: "/#about" },
            { name: "Menü", href: "/#menu" },
            { name: "Referenzen", href: "/#testimonials" },
            { name: "Kontakt", href: "/#contact" }
        ],
        legal: [
            { name: "Impressum", href: "/impressum" },
            { name: "Datenschutz", href: "/datenschutz" },
        ]
    }
} as const 